<template>
  <div class="wrapper signup-page-wrp">
    <div class="signup-page" v-if="step == 1">
      <div class="signup-page-left">
        <div class="align">
          <div class="logo"><a href="javascrpt:void(0)"><img
            :src="require('@/assets/images/CleverStaff_Signin_Logo .svg')" width="222" height="152"
            alt="Pavagt-logo"></a></div>
        </div>
      </div>
      <div class="signup-page-right">
        <div class="align">
          <div class="signin-form ">
            <div class="step-holder">
              <div class="tab-heading">
                <h1>Forgot Password</h1>
              </div>
              <div class="stepper-wrapper">
                <div class="stepper-item active">
                  <div class="step-counter"></div>
                  <div class="step-name"> Enter Email</div>
                </div>
              </div>
              <!-- Step 1 -->
              <div class="steps ">
                <div class="form-row phone-step">
                  <div class="form-group col-sm-12 col-md-8">
                    <label>Email </label>
                    <div class="input-wrapper wrap4">
                      <input type="email" autocomplete="off" class="form-control form-control-lg"
                             id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="" v-model="form.email">
                    </div>
                    <p v-text="errormessage" class="text-danger">sad</p>
                  </div>

                </div>

              </div>

              <div class="tab-foot text-center">
                <router-link to="/">
                  <span class="btn btn-lg btn-cancel ">Cancel </span>
                </router-link>
                <button class="btn btn-lg btn-primary" @click.prevent="forgotpassword">Continue</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="signup-page" v-if="step == 2">
      <div class="signup-page-left">
        <div class="align">
          <h1>Verification</h1>
          <p>Enter the 4-digit code</p>
        </div>
      </div>
      <div class="signup-page-right">
        <div class="align">
          <div class="signin-form ">
            <div class="step-holder">
              <div class="tab-heading">
                <h1>Sign Up</h1>
              </div>

              <div class="stepper-wrapper">
                <div class="stepper-item active complete">
                  <div class="step-counter"></div>
                  <div class="step-name">3. Email</div>
                </div>
                <div class="stepper-item active complete">
                  <div class="step-counter"><i class="ico ico-mobile"></i></div>
                  <div class="step-name">4. Verification</div>
                </div>
              </div>


              <!-- Step 1 -->
              <div class="steps ">

                <div class="verification text-center">

                  <p>A new verification code has been sent to </p>
                  <a href="javascript:void(0)">{{ form.email }}</a>
                  <p>{{ form.phone }}</p>

                </div>

                <div class="form-row phone-step">
                  <ul class="otp-code" id="autojump">
                    <li>
                      <div class="input-wrapper  form-wrap-cus">
                        <input type="tel" v-on:keyup="nextSwitchFunc" class="form-control form-control-lg" maxlength="1" @keyup.delete="triggerDBKey" ref="otp1" data-otp="1"
                               v-model="verification_code[0]">
                      </div>
                    </li>
                    <li>
                      <div class="input-wrapper form-wrap-cus">
                        <input type="tel" v-on:keyup="nextSwitchFunc" class="form-control form-control-lg" maxlength="1" @keyup.delete="triggerDBKey" ref="otp2" data-otp="2"
                               v-model="verification_code[1]">
                      </div>
                    </li>
                    <li>
                      <div class="input-wrapper form-wrap-cus">
                        <input type="tel" v-on:keyup="nextSwitchFunc" class="form-control form-control-lg" maxlength="1" @keyup.delete="triggerDBKey" ref="otp3" data-otp="3"
                               v-model="verification_code[2]">
                      </div>
                    </li>
                    <li>
                      <div class="input-wrapper form-wrap-cus">
                        <input type="tel" v-on:keyup="nextSwitchFunc" class="form-control form-control-lg" maxlength="1" @keyup.delete="triggerDBKey" ref="otp4" data-otp="4"
                               v-model="verification_code[3]">
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="tab-foot text-center">
                <span class="btn btn-lg btn-block btn-primary" @click.prevent="verifyPhoneNumber"> Verify</span>
                <router-link :to="{ name: 'login'}">
                  <span class="btn btn-lg btn-cancel ">Cancel </span>
                </router-link>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="signup-page signin-page" v-if="step == 3">
      <div class="signup-page-left">
        <div class="align">
          <div class="logo"><a href="javascrpt:void(0)"><img
            :src="require('@/assets/images/CleverStaff_Signin_Logo .svg')" width="222" height="152"
            alt="Pavagt-logo"></a></div>
        </div>
      </div>
      <div class="signup-page-right">
        <div class="align">
          <form class="signin-form">
            <!-- Tab panes -->
            <div class="tab-content ">
              <div role="tabpanel" class="tab-pane active" id="manager">
                <div class="tab-heading">
                  <h1>Create New Password</h1>
                </div>
                <div class="tab-form">
                  <div class="form-group">
                    <label>Password </label>
                    <div class="input-wrapper wrap4">
                      <input type="password" autocomplete="off" class="form-control form-control-lg"
                             id="signin-password2" aria-describedby="emailHelp" placeholder=""
                             v-validate="{ required:true, regex: /|^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*).{8,}$/ }"
                             v-model="password" @change="validateInput('password')">
                      <i class="ico-sec ico-eye_selected mg-pass"></i>
                    </div>
                    <p v-if="validity.password === 'invalid'" :class="{textRed : validity.password === 'invalid'}">Enter
                      valid password</p>
                  </div>
                  <div class="required-meaages">
                    <h4>Password requirements:</h4>
                    <p>Must contain 8 characters, At least one letter,
                      one capital letter, One number and one special char.</p>
                  </div>

                  <div class="form-group">
                    <label>Confirm Password </label>
                    <div class="input-wrapper wrap3">
                      <input type="password" autocomplete="off" class="form-control form-control-lg"
                             id="signin-password" aria-describedby="emailHelp" placeholder=""
                             v-validate="'required|confirmed:password'"
                             v-model="password_confirmation" @change="validateInput('password_confirmation')">
                      <i class="ico-sec ico-eye_selected em-pass"></i>
                    </div>
                    <p v-if="validity.password_confirmation === 'invalid'"
                       :class="{textRed : validity.password_confirmation === 'invalid'}">Enter confirm password</p>
                    <p v-if="validity.password_confirmation === 'invalid-match'"
                       :class="{textRed : validity.password_confirmation === 'invalid-match'}">Password not matched</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-foot text-center">
              <router-link to="/">
                <span class="btn btn-lg btn-outline-primary">Cancel </span>
              </router-link>
              <button class="btn btn-lg btn-outline-primary" @click.prevent="createNewPassword">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import Multiselect from 'vue-multiselect';
import {
  required,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";

export default {
  name: 'forgotpassword',
  components: {VueTelInput, Multiselect},
  data() {
    return {
      form: {
        phone: null,
        email: null
      },
      step: 1,
      verification_code: [],
      password: "",
      password_confirmation: "",
      errormessage: '',
      validity: {
        email: '',
        password: '',
      },
    }
  },
  methods: {
    forgotpassword() {
      const headers = {
        'Content-Type': 'application/json',
        'Device-Type': 'web'
      }
      if (this.form.email == null) {
        // alert('Enter Email please');
      }
      this.$axios.post(this.$Forgotpassword, this.form, {headers: headers})
        .then(response => {
          if (response.data.status === 200) {
            this.nextstep();
          }
          if (response.data.status === 422) {
            this.errormessage = response.data.message
          }
        }).catch(error => {
        this.is_data_ready = true
      });
    },
    nextstep() {
      this.step++;
    },
    previousstep() {
      this.step--;
    },
    verifyPhoneNumber() {
      let data = {
        email: this.form.email,
        verification_code: this.verification_code.join(''),
      };
      this.$root.$emit('activeCompoClick');

      this.$axios({
        method: 'post',
        data: $.param(data),
        url: this.$VerifyCode,
      }).then(response => {
          if (response.data.status === 200) {
            // console.log('hello',response.data.status);
            this.nextstep();
          } else if (response.data.status === 402) {
            alert('Verification Code is Invalid Or Expired')
          }
        }
      ).catch(error => {
        console.log(error);
        this.is_data_ready = true
      });


    },
    nextSwitchFunc(e) {
      if($(e.target).attr('data-otp') == 1){
        this.$refs.otp2.focus();
      }else if($(e.target).attr('data-otp') == 2){
        this.$refs.otp3.focus();
      }else if($(e.target).attr('data-otp') == 3){
        this.$refs.otp4.focus();
      }
    },
    triggerDBKey(e) {
      if($(e.target).attr('data-otp') == 2){
        this.$refs.otp1.focus();
      }else if($(e.target).attr('data-otp') == 3){
        this.$refs.otp2.focus();
      }else if($(e.target).attr('data-otp') == 4){
        this.$refs.otp3.focus();
      }else if($(e.target).attr('data-otp') == 1){
        this.$refs.otp1.focus();
      }
    },
    createNewPassword() {
      if (this.validateInput()) {
        let data = {
          email: this.form.email,
          verification_code: this.verification_code.join(''),
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          fcm_token: 'web',
          password: this.password,
          password_confirmation: this.password_confirmation
        };
        this.$axios({
          method: 'post',
          data: $.param(data),
          url: this.$ResetPassword,
        }).then(response => {
            if (response.data.status === 200) {
              alert('User Password Successfully Changed');
              this.$router.push({name: 'login'});
            }
            if (response.data.status === 402) {
              alert('you cannot used old password');
            }
          }
        ).catch(error => {
          console.log(error);
          this.is_data_ready = true
        });

      }

    },
    validateInput(fieldname = '') {
      if (fieldname === 'password' || fieldname === '') {
        if (this.password === '') {
          this.validity.password = 'invalid'
        } else {
          this.validity.password = ''
        }

      }
      if (fieldname === 'password_confirmation' || fieldname === '') {
        if (this.password_confirmation === '') {
          this.validity.password_confirmation = 'invalid'
        } else if (this.$validator.errors.has('password_confirmation') == true) {
          this.validity.password_confirmation = 'invalid-match'
        } else {
          this.validity.password_confirmation = '';
        }
      }
      if (this.validity.password == '' && this.validity.password_confirmation == '') {
        return true
      } else {
        return false
      }
    },
  }
}
</script>
<style scoped>
.signin-page .form-control-lg{
  margin-bottom: 5px !important;
}
</style>
